export default function parameterizeArray(name, params) {
	return params.map(p => name + '=' + p).join('&');
}
